module.exports = __webpack_public_path__ + "img/blog-light.09ee6fe8.png";